module.exports = __webpack_public_path__ + "static/media/balloon-v3.1ff0f9af.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/balloon-v3.svg
// module id = 88
// module chunks = 0